class TopImageSwiper {

  constructor(el, opt) {
    this.el = el;
    if (document.querySelector(this.el)) {
      this.event();
    }
  }
  event() {
    const swiper = document.querySelector(this.el);
    new Swiper(swiper,{
      loop: true,
      speed: 40000,
      slidesPerView: 'auto',
      allowTouchMove: false,
      autoplay: {
        delay: 0
      }
    })
  }
} 